<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
let type = navigator.appName
let lang = ''
if (type === 'Netscape') {
  lang = navigator.language
} else {
  lang = navigator.userLanguage
}
lang = lang.substr(0, 2)
if (lang === 'zh') {
  localStorage.setItem('lang', 'zh')
} else if (lang === 'en') {
  localStorage.setItem('lang', 'en')
} else {
  localStorage.setItem('lang', 'zh')
};

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
body {
  display: block;
  margin: 0px;
  background-color: rgba(0,17,51,1);
}
</style>



// WEBPACK FOOTER //
// src/App.vue